import React, { useState } from "react";
import "./Tutorial.css";

const hints = [
  [null, null],
  [
    <p>
      Move forward by DRAGGING the
      <span className="hint-player">WAND</span>
      card to the next column
    </p>,
    <p>
      The
      <span className="hint-hp">HP (top left, red)</span>
      and
      <span className="hint-mp">MP (bottom right, blue)</span>
      of the card you&apos;ve landed on will be added to the
      <span className="hint-player">WAND</span>
      card
    </p>,
  ],
  [
    <p>
      You are out of
      <span className="hint-mp">MP.</span>
      Rewind by DRAGGING the
      <span className="hint-player">WAND</span>
      card to the previous card along your path (white line)
    </p>,
    <p>
      The
      <span className="hint-hp">HP (top left, red)</span>
      and
      <span className="hint-mp">MP (bottom right, blue)</span>
      of the card you previously selected have been reversed and will be added to the
      <span className="hint-player">WAND</span>
      card
    </p>,
  ],
  [
    <div>
      <p>
        To GET
        <span className="hint-coin">coins,</span>
        DRAG the
        <span className="hint-player">WAND</span>
        card to a card with positive
        <span className="hint-coin">coins(top right, gold)</span>
      </p>
      <p>
        To SPEND
        <span className="hint-coin">coins,</span>
        DRAG the
        <span className="hint-player">WAND</span>
        card to a card with negative
        <span className="hint-coin">coins(top right, gold)</span>
      </p>
    </div>,
    <div>
      <p>
        If you have enough coins when you SPEND coins, the negative effects of a card become
        positive.
        <br />
        <i>
          ( Example:
          <span className="hint-hp">-6</span>
          <span>/</span>
          <span className="hint-mp">+1</span>
          becomes
          <span className="hint-hp">+6</span>
          <span>/</span>
          <span className="hint-mp">+1</span>
          <span>)</span>
        </i>
      </p>
    </div>,
  ],
];

interface ITutorialProps {
  step: number;
  close: () => void;
}

const HINT_TOLERANCE = 2;
const STEPS_FOLDER = `${process.env.PUBLIC_URL}/tutorial_steps/`;

export default function Tutorial(props: ITutorialProps) {
  const { step, close } = props;
  const [top, bottom] = hints[step] ?? [];

  const [hintCounter, setHintCounter] = useState(0);
  if (step === 0 || (step === 2 && hintCounter >= HINT_TOLERANCE)) return null;

  const onConfirm = () => {
    setHintCounter((counter) => counter + 1);
    close();
  };
  return (
    <div className="tutorial">
      {top}
      <img src={`${STEPS_FOLDER}/step${step}.gif`} alt={`tutorial step ${step}`} />
      {bottom}
      <button type="button" onClick={onConfirm}>
        Confirm
      </button>
    </div>
  );
}
